export default __webpack_public_path__ + "static/media/ic_greece.59604838.svg";